(function ($) {
  'use strict';

  if (!$.tangible) {
    $.tangible = new Object();
  };

  $.tangible.shortcutNavigation = function (el, options) {
    var base = this;

    base.$el = $(el);
    base.el = el;

    base.init = function () {

      base.$btnClosePaxGuide = $('.js-closeMegaMenu');
      base.$collapsibleContent = $('.o-collapsible__content');
      base.$btnCollapsible = $('.c-navigation-shortcuts .has-dropdown button');

      base.$btnClosePaxGuide.click(function () {
        base.closePaxguide($(this));
      });

      base.$btnCollapsible.click(function () {
        base.toggleClasses($(this));
        base.hideDropdowns();
        base.showDropdown($(this));
        base.toggleArrowClass($(this));
        $('.c-overlay').toggleClass('is-visible');
      });

    };

    base.init();

    $(document).mouseup(function (e) {

      var container = $('.has-dropdown.is-opened');
      var arrow = $('.c-navigation-shortcuts__dropdown').prev('.arrow');
      var collapsibleTitle = $('.c-navigation-shortcuts__dropdown .js-collapsible-title button');

      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        base.$btnClosePaxGuide.closest(base.$collapsibleContent).attr('hidden', true);
        collapsibleTitle.attr('aria-expanded', false);
        arrow.removeClass('is-visible');
        container.removeClass('is-opened');
        $('.c-overlay').removeClass('is-visible');
        // console.log("chiude");
      }
    });

    // Closes passenger guide
    base.closePaxguide = function (closeBtn) {
      closeBtn.closest(base.$collapsibleContent).attr('hidden', true);
      $('.js-collapsible-title .c-navigation-item').attr('aria-expanded', false);
      $('.c-navigation-shortcuts__dropdown').prev('.arrow').removeClass('is-visible');
      // console.log("eccolo");

    };

    // Moves opened class through .has-dropdown elements
    base.toggleClasses = function (thisBtn) {
      thisBtn.closest('.has-dropdown').toggleClass('is-opened');

    };

    // Hides all the dropdowns
    base.hideDropdowns = function () {
      base.$btnCollapsible.closest('.has-dropdown').find('.c-navigation-item').attr('aria-expanded', 'false')
      base.$btnCollapsible.closest('.has-dropdown').find('.o-collapsible__content').attr('hidden', 'true');
      // console.log("chiude");

    };

    // Shows selected dropdown
    base.showDropdown = function (thisBtn) {
      thisBtn.closest('.has-dropdown.is-opened').find('.c-navigation-item').attr('aria-expanded', 'true')
      thisBtn.closest('.has-dropdown.is-opened').find('.o-collapsible__content').removeAttr('hidden');
      // console.log("apre");
    };

    // Toggle arrow class
    base.toggleArrowClass = function (thisBtn) {
      base.$btnCollapsible.closest('.has-dropdown').find('.arrow').removeClass('is-visible');
      thisBtn.closest('.has-dropdown.is-opened').find('.arrow').addClass('is-visible');
    };

    // Removes is-opened class to all the elements except the selected one
    $('.c-navigation-shortcuts').on('click', '.has-dropdown.is-opened', function () {
      $('.has-dropdown.is-opened').not($(this)).removeClass('is-opened');
    });

  };

  $.fn.tangible_shortcutNavigation = function (options) {
    return this.each(function () {
      (new $.tangible.shortcutNavigation(this, options));
    });
  };

})(jQuery);
